import MiniProgramPage from 'D:/HBuilderProjects/园博园/pages/ucenter/my-booking.vue'
wx.createPage(MiniProgramPage)